export type TransactionId = number;

export enum TransactionType {
  Deposit = "deposit",
  Withdrawal = "withdrawal",
}
